import React from 'react';
import Hero from '../components/dcapital/Hero';
import Steps from '../components/dcapital/Steps';
import StatsWidget from '../components/dcapital/StatsWidget';
import { Terms, Referral } from '../components/dcapital/Terms';
import { Know, Faq, Risk, FinalCta } from '../components/dcapital/Info';
import { REFERRAL_ENABLED, STATS_ENABLED } from '../components/dcapital/links';

export default function DCapital() {
  return (
    <main data-testid="dcapital-page">
      <Hero />
      {STATS_ENABLED && <StatsWidget />}
      <Steps />
      <Terms />
      {REFERRAL_ENABLED && <Referral />}
      <Know />
      <Faq />
      <Risk />
      <FinalCta />
    </main>
  );
}
